// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".communication-type-info-icon__popover-content{max-width:280px}.communication-type-info-icon.ui-popover.show .popover.show.bs-popover-auto{z-index:1500}", ""]);
// Exports
module.exports = exports;
